/* global $ */
/**
 * This interceptor add a class to the #main div corresponding to the current route
 * The main purpose is to display different background depending on current screen
 */
module.exports = [
    {
        type: "navigation", //called on navigation
        interceptor: function (app, context, next){

            var allDropDown = document.querySelectorAll(".bs-container.dropdown") ;

            for(var i=0; i<allDropDown.length; i++){
                var elParent = allDropDown[i].parentElement ;
                if(elParent){
                    elParent.removeChild(allDropDown[i]) ;
                }
            }

            next() ;
        }
    }
];